var render, staticRenderFns
import script from "./AppSnack.vue?vue&type=script&lang=js&"
export * from "./AppSnack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0868e86",
  null
  
)

export default component.exports